import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authHelpers } from '../global/supabase';
import '../global/styles.css';

function AuthCallback() {
  const navigate = useNavigate();
  const { isAuthenticated, userProfile, initialized } = useAuth();
  const [hasProcessed, setHasProcessed] = useState(false);

  useEffect(() => {
    // Wait for AuthContext to initialize
    if (!initialized) {
      console.log('AuthCallback: Waiting for auth to initialize...');
      return;
    }

    // Prevent double processing
    if (hasProcessed) return;

    console.log('AuthCallback: Processing...', { isAuthenticated, userProfile });

    if (isAuthenticated && userProfile) {
      setHasProcessed(true);

      // Check if user has complete profile
      if (userProfile.firstName && userProfile.lastName && userProfile.profileCompleted && userProfile.stateLicenseNumber) {
        console.log('AuthCallback: Existing user with complete profile, going to home');
        authHelpers.markOnboardingComplete();
        navigate('/home', { replace: true });
      } else {
        console.log('AuthCallback: User needs to complete profile');
        authHelpers.markOnboardingComplete();
        navigate('/complete-profile', { replace: true });
      }
    } else if (isAuthenticated && !userProfile) {
      // User authenticated but no profile yet - wait a bit for profile to load
      console.log('AuthCallback: User authenticated, waiting for profile...');
    } else if (!isAuthenticated) {
      setHasProcessed(true);
      console.log('AuthCallback: Not authenticated, redirecting to login');
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    }
  }, [initialized, isAuthenticated, userProfile, hasProcessed, navigate]);

  return (
    <div className="container-center">
      <div className="card">
        <h2 className="title-auth">Completing Sign In...</h2>

        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <div className="spinner" style={{
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #3498db',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }}></div>
          <p style={{ marginTop: '1rem', color: '#666' }}>
            Please wait while we sign you in...
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default AuthCallback;
